import React, { useEffect, useState } from "react";
import { Smartphone } from "lucide-react";
import { api } from "@/lib/api";

function Stat({ label, value, id }) {
  return (
    <div>
      <p className="font-sans text-[0.6rem] uppercase tracking-[0.24em] text-bone-500">{label}</p>
      <p className="font-serif text-2xl text-bone-100" data-testid={id}>{value}</p>
    </div>
  );
}

export default function MobileBarStats() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/events/mobile-bar").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;
  return (
    <section className="border border-obsidian-600 p-6 mb-10" data-testid="mobile-bar-stats">
      <div className="flex items-center gap-2 mb-1">
        <Smartphone className="h-4 w-4 text-terracotta" />
        <h2 className="font-serif text-2xl text-bone-100">Phone bar</h2>
      </div>
      <p className="font-sans text-sm text-bone-400 mb-5">
        The sticky "Try Chapter One" bar on phones. Counted once per browser session. "Started" = tapped the bar, then heard the Mirror on /try.
      </p>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {[["home", "Home"], ["pricing", "Pricing"]].map(([p, pageLabel]) => (
          <div key={p} className="border border-obsidian-700 p-4" data-testid={`mobile-bar-stats-${p}`}>
            <p className="font-serif text-xl text-bone-100 mb-3">{pageLabel}</p>
            {[["d7", "Last 7 days"], ["d30", "Last 30 days"]].map(([k, label]) => {
              const w = data.pages[p][k];
              return (
                <div key={k} className="border-t border-obsidian-600 pt-3 mb-3" data-testid={`mobile-bar-stats-${p}-${k}`}>
                  <p className="font-sans text-xs uppercase tracking-[0.24em] text-terracotta mb-2">{label}</p>
                  <div className="grid grid-cols-4 gap-3">
                    <Stat label="Views" value={w.views} id={`mobile-bar-${p}-${k}-views`} />
                    <Stat label="Taps" value={w.taps} id={`mobile-bar-${p}-${k}-taps`} />
                    <Stat label="Tap rate" value={`${w.tap_rate}%`} id={`mobile-bar-${p}-${k}-rate`} />
                    <Stat label="Started" value={w.started} id={`mobile-bar-${p}-${k}-started`} />
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </section>
  );
}
